export const PersonaCreationActionTypes = {
    CREATE_BULK: 'CREATE_BULK',
    CREATE_SINGLE: 'CREATE_SINGLE',
    UPLOAD_ZIP_FILE: 'UPLOAD_ZIP_FILE',
    UPLOAD_SKILLS_EXCEL: 'UPLOAD_SKILLS_EXCEL',
    UPLOAD_ROLES_SKILLS_EXCEL: 'UPLOAD_ROLES_SKILLS_EXCEL',
    UPLOAD_FROM_HRMS: 'UPLOAD_FROM_HRMS'
};
